import classNames from 'classnames'
import React from 'react'
import { InternalExternalLink } from '../../types/InternalExternalLink'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { Button } from '../Button'
import { Image, ImageProps } from '../Image'
import { MarketSection } from '../MarketSection'
import { Paragraph } from '../Paragraph'

export interface FullWidthTeaserProps {
  id?: string
  image?: ImageProps
  link?: InternalExternalLink
  text?: string
  title?: string
}

export const FullWidthTeaser = ({
  id,
  image,
  link,
  text,
  title,
}: FullWidthTeaserProps) => (
  <MarketSection additionalClassName="gap-y-30" id={id}>
    {image && (
      <div
        className={classNames(
          'col-span-full',
          'sm:mx-120',
          'md:col-start-4 md:col-span-3 md:mx-0',
          'lg:col-start-5 lg:col-span-3 lg:my-20 lg:-mr-75',
          'xl:col-start-6 xl:col-span-4 xl:-mr-45',
          'xxl:col-start-8 xxl:col-span-4'
        )}
      >
        <Image {...image} applyLqip imgClassName="rounded-15 w-full" loading="lazy" />
      </div>
    )}

    <div
      className={classNames(
        'col-span-full flex flex-col gap-30 mx-60',
        'sm:col-start-2 sm:col-span-4',
        'md:col-start-1 md:col-span-3 md:row-start-1',
        'lg:col-start-2 lg:col-span-3 lg:-ml-75',
        'xl:col-start-2 xl:col-span-4 xl:-ml-45',
        'xxl:col-start-4 xxl:col-span-4'
      )}
    >
      {!isNullOrWhiteSpace(title) && (
        <h2 className="font-h2 text-h2 text-primary">{title}</h2>
      )}

      {!isNullOrWhiteSpace(text) && (
        <Paragraph className="font-body text-body text-secondary-darker">
          {text}
        </Paragraph>
      )}

      {link && !isNullOrWhiteSpace(link.title) && !isNullOrWhiteSpace(link.url) && (
        <Button
          additionalClassName="self-start"
          isExternalUrl={link.isExternal}
          url={link.url}
        >
          {link.title}
        </Button>
      )}
    </div>
  </MarketSection>
)
